import { parseKickoffUtcMs } from "@/lib/kickoffTime";

const APP_TZ = "Europe/Stockholm";
const BROADCAST_MATCHDAY_CUTOFF_HOUR = 6;

function stockholmParts(ms) {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: APP_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    hourCycle: "h23",
  }).formatToParts(new Date(ms));
  const get = (type) => parts.find((p) => p.type === type)?.value ?? "";
  return {
    y: get("year"),
    m: get("month"),
    d: get("day"),
    h: parseInt(get("hour"), 10) || 0,
  };
}

function addDaysIso(iso, delta) {
  const [Y, M, D] = iso.split("-").map(Number);
  const dt = new Date(Date.UTC(Y, M - 1, D + delta));
  return dt.toISOString().slice(0, 10);
}

/** Svensk spelkväll: kväll + natt till 06:00 = samma matchdag (samma som backend). */
export function broadcastMatchdayIso(kickoff) {
  const ms = parseKickoffUtcMs(kickoff);
  if (ms == null) return null;
  const { y, m, d, h } = stockholmParts(ms);
  const iso = `${y}-${m}-${d}`;
  return h <= BROADCAST_MATCHDAY_CUTOFF_HOUR ? addDaysIso(iso, -1) : iso;
}

export function calendarTodayStockholm(nowMs = Date.now()) {
  const { y, m, d } = stockholmParts(nowMs);
  return `${y}-${m}-${d}`;
}

/** Aktuell spelkväll: pågående/natt, annars nästa, annars senaste. */
export function resolveActiveBroadcastMatchday(fixtures, { nowMs = Date.now() } = {}) {
  const bdays = [
    ...new Set(
      (fixtures || [])
        .map((f) => broadcastMatchdayIso(f.kickoff))
        .filter(Boolean),
    ),
  ].sort();
  if (!bdays.length) return null;

  const nowBday = broadcastMatchdayIso(new Date(nowMs).toISOString());
  if (nowBday && bdays.includes(nowBday)) return nowBday;

  const upcoming = bdays.filter((b) => b >= (nowBday || calendarTodayStockholm(nowMs)));
  if (upcoming.length) return upcoming[0];

  return bdays[bdays.length - 1];
}

export function fixturesOnBroadcastMatchday(fixtures, matchdayIso) {
  if (!matchdayIso) return [];
  return (fixtures || []).filter((f) => broadcastMatchdayIso(f.kickoff) === matchdayIso);
}

export function formatBroadcastMatchdayLabel(iso, lang = "sv") {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  const loc = lang === "en" ? "en-GB" : "sv-SE";
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString(loc, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
